import { render, staticRenderFns } from "./BaseLanguage.vue?vue&type=template&id=686a4045&"
import script from "./BaseLanguage.vue?vue&type=script&lang=js&"
export * from "./BaseLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports